import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "surface1" }, [
      _createElementVNode("path", {
        style: {"stroke":"none","fill-rule":"nonzero","fill":"rgb(0%,0%,0%)","fill-opacity":"1"},
        d: "M 12 12 C 14.476562 12 16.5 9.976562 16.5 7.5 C 16.5 5.023438 14.476562 3 12 3 C 9.523438 3 7.5 5.023438 7.5 7.5 C 7.5 9.976562 9.523438 12 12 12 Z M 12 14.25 C 9.019531 14.25 3 15.769531 3 18.75 L 3 21 L 21 21 L 21 18.75 C 21 15.769531 14.980469 14.25 12 14.25 Z M 12 14.25 "
      })
    ], -1)
  ])))
}
export default { render: render }